import { useState } from 'react';
import './Login.css';

function Login({
  onLoginSubmit,
  onChangePasswordSubmit,
  error,
  setError,
  loading,
  forcePasswordChange,
  tempUser
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    onLoginSubmit(username, password);
  };

  const handleChangePassword = (e) => {
    e.preventDefault();
    setError('');

    if (newPassword.length < 6) {
      setError('Passwort muss mindestens 6 Zeichen lang sein');
      return;
    }

    if (newPassword !== newPasswordConfirm) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    onChangePasswordSubmit(newPassword);
  };

  // FORCE PASSWORD CHANGE VIEW
  if (forcePasswordChange && tempUser) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>Passwort ändern erforderlich</h1>
          <p>Sie müssen Ihr Passwort ändern, bevor Sie fortfahren können.</p>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleChangePassword}>
            <div className="form-group">
              <label>Benutzer</label>
              <input
                type="text"
                value={tempUser.name}
                disabled
                style={{ background: '#f5f5f5', cursor: 'not-allowed' }}
              />
            </div>

            <div className="form-group">
              <label>Neues Passwort</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Mindestens 6 Zeichen"
                required
              />
            </div>

            <div className="form-group">
              <label>Passwort bestätigen</label>
              <input
                type="password"
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
                placeholder="Passwort wiederholen"
                required
              />
            </div>

            <button type="submit" disabled={loading}>
              {loading ? 'Wird geändert...' : 'Passwort ändern und einloggen'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  // NORMAL LOGIN VIEW
  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Optimox-Manager</h1>
        <p>Melden Sie sich an</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Benutzername</label>
            <input
              type="text"
              placeholder="Benutzername / E-Mail"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label>Passwort</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          <button type="submit" disabled={loading}>
            {loading ? 'Anmelden...' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;